import React, { useRef, useState, useEffect, useCallback } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { IconBateuLevou, IconVloz, IconSuper4 } from "~misc/icons";

const tabs = [
  {
    key: "bateu-levou",
    path: "/gestao-de-vendas/bateu-levou",
    icon: <IconBateuLevou />,
    alt: "Bateu Levou",
  },
  {
    key: "vloz",
    path: "/gestao-de-vendas/vloz",
    icon: <IconVloz />,
    alt: "Vloz",
  },
  {
    key: "super4",
    path: "/gestao-de-vendas/super4",
    icon: <IconSuper4 />,
    alt: "Super4",
  },
];

const ProgramasNavigation = ({ children }) => {
  const { pathname } = useLocation();
  const tabRefs = useRef({});
  const panelRef = useRef(null);
  const [arrowLeft, setArrowLeft] = useState(null);

  const calcArrow = useCallback(() => {
    const activeTab = tabs.find(
      (t) => pathname === t.path || pathname.startsWith(t.path + "/")
    );
    if (!activeTab || !tabRefs.current[activeTab.key] || !panelRef.current) return;

    const tabRect = tabRefs.current[activeTab.key].getBoundingClientRect();
    const panelRect = panelRef.current.getBoundingClientRect();
    setArrowLeft(tabRect.left - panelRect.left + tabRect.width / 2);
  }, [pathname]);

  useEffect(() => {
    calcArrow();
    window.addEventListener("resize", calcArrow);
    return () => window.removeEventListener("resize", calcArrow);
  }, [calcArrow]);

  return (
    <div>
      <nav className="full-screen-width px-6 py-5">
        <div className="container flex justify-between items-center gap-6">
          {tabs.map((tab) => {
            const isActive =
              pathname === tab.path || pathname.startsWith(tab.path + "/");

            return (
              <NavLink
                key={tab.key}
                to={tab.path}
                ref={(el) => (tabRefs.current[tab.key] = el)}
                className={`flex items-center justify-center rounded-xl px-10 py-6 transition-all duration-200 w-84 h-32 ${
                  isActive
                    ? "shadow-lg opacity-100 bg-white border border-gray-200"
                    : "opacity-40 grayscale hover:opacity-70 hover:grayscale-0 hover:shadow-md"
                }`}
              >
                <div className={`flex items-center justify-center transition-all duration-200 ${isActive ? "w-28 h-28" : "w-20 h-20"}`}>
                  {tab.icon}
                </div>
              </NavLink>
            );
          })}
        </div>
      </nav>
      {children && (
        <div ref={panelRef} className="container relative bg-white shadow-sm rounded-xl mt-1 px-2 py-6">
          {arrowLeft !== null && (
            <div
              className="absolute -top-3 w-0 h-0 transition-all duration-300"
              style={{
                left: arrowLeft,
                transform: "translateX(-50%)",
                borderLeft: "14px solid transparent",
                borderRight: "14px solid transparent",
                borderBottom: "14px solid white",
              }}
            />
          )}
          {children}
        </div>
      )}
    </div>
  );
};

export default ProgramasNavigation;
